// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"city-4"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16 21V10L12 8L8 10V21H16Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M3 21H8V5L5.5 3L3 5V21Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M21 21V5L18.5 3L16 5V21H21Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M11 13H13M12 21V17","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 21H3V5L5.5 3L8 5V21ZM8 21H16M16 21H21V5L18.5 3L16 5V21ZM8.5 9.75L12 8L15.5 9.75","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const City4Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-4',
    ref,
    icon: element,
  },
));

City4Icon.displayName = 'City4Icon';

export default City4Icon;
